
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 116 90"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"115","height":"89","x":".5","y":".5","fill":"#FFF","stroke":"#71798A","rx":"4"}}),_c('path',{attrs:{"fill":"#003457","fill-rule":"nonzero","d":"M97.815 25.152l-2.297 2.296 6.024 6.024v19.911a1.625 1.625 0 11-3.25 0v-8.666a4.875 4.875 0 00-4.875-4.875h-1.625V22.508h-29.25v40.625a2.708 2.708 0 01-2.709 2.709v3.25H94.5v-3.25a2.708 2.708 0 01-2.708-2.709V43.092h1.625a1.647 1.647 0 011.625 1.625v8.666a4.875 4.875 0 109.75 0V32.128l-6.977-6.976zm-9.273.606v14.084h-8.299l3.835-9.035c.39-1.105-.715-1.755-1.516-.91l-7.93 9.945h-8.84V25.758h22.75zm-23.4 40.084a5.937 5.937 0 00.65-2.709V43.092h22.75v20.041c-.002.942.221 1.87.65 2.709h-24.05z"}}),_c('path',{attrs:{"d":"M25.802 48l6.977 8.38a9.1 9.1 0 11-13.823.543L25.802 48zM15.4 36.2l3.498 4.198a4.55 4.55 0 11-6.898.236l3.4-4.434zM40.33 14l9.897 12.427a12.693 12.693 0 013.253 8.503c0 7.036-5.704 12.74-12.74 12.74-7.036 0-12.74-5.704-12.74-12.74a12.69 12.69 0 013.117-8.35L40.33 14z","stroke":"#BEC8D9","stroke-width":"2.6"}}),_c('path',{attrs:{"stroke":"#05B5E4","stroke-width":"3.9","d":"M34 34c.37 4.61 2.857 7.19 7.459 7.735"}}),_c('path',{attrs:{"stroke":"#05B5E4","stroke-width":"2.6","d":"M22 62c.347 3.15 1.923 4.726 4.726 4.726"}})])])
          )
        }
      }
    